/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { useLocation, Route, Switch } from 'react-router-dom';
import NotFound from 'yoda-app-shell/lib/components/NotFound/NotFound';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import TrackOrderConnectLazy from './components/TrackOrder/TrackOrderConnectLazy';
import OrderDetailsConnectLazy from './containers/Pages/OrderDetails/OrderDetailsConnectLazy';
import CSPLandingConnectLazy from './containers/Pages/CurbSidePickUp/CSPLanding/CSPLandingConnectLazy';
import CSPProgressConnectLazy from './containers/Pages/CurbSidePickUp/CSPProgress/CSPProgressConnectLazy';
import OrdersLazy from './containers/Pages/Orders/OrdersConnectLazy';
import MarketplaceReturnsLazy from './containers/Pages/MarketplaceReturns/MarketplaceReturnLazy';

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

const App = () => (
    <>
        <ScrollToTop />
        <Switch>
            <Route exact path="/" render={(props) => <OrdersLazy {...props} />} />
            <Route exact strict path="/orders" render={(props) => <OrdersLazy {...props} />} />
            <Route
                strict
                path="/orders/trackorders"
                render={(props) => <TrackOrderConnectLazy {...props} />}
            />
            <Route
                strict
                path="/orders/orderdetails"
                render={(props) => <OrderDetailsConnectLazy {...props} />}
            />
            <Route
                strict
                path="/orders/return"
                render={(props) => <MarketplaceReturnsLazy {...props} />}
            />
            <Route
                exact
                strict
                path="/orders/curbside"
                render={(props) => <CSPLandingConnectLazy {...props} />}
            />
            <Route
                strict
                path="/orders/curbside/status"
                render={(props) => <CSPProgressConnectLazy {...props} />}
            />
            <Route render={() => <NotFound />} />
        </Switch>
    </>
);
App.Layout = Layout;
export default App;
